var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { confirm } from '../../../core/components/Confirm';
import { ExtraActionContainer, ExtraActionContainerHeader, ExtraActionContainerBody, ExtraActionButton, ExtraActionPrimaryButton, PlusIcon, Footer, } from './styles';
import useCommunity from '../../../social/hooks/useCommunity';
const ExtraAction = ({ title, bodyText, actionButton }) => {
    return (React.createElement(ExtraActionContainer, null,
        React.createElement(ExtraActionContainerHeader, null, title),
        React.createElement(ExtraActionContainerBody, null,
            React.createElement("div", null, bodyText),
            React.createElement(Footer, null, actionButton))));
};
const AddMemberButton = ({ onClick }) => {
    return (React.createElement(ExtraActionPrimaryButton, { "data-qa-anchor": "community-edit-add-member-button", onClick: onClick },
        React.createElement(PlusIcon, null),
        React.createElement(FormattedMessage, { id: "add" })));
};
const CloseCommunityButton = (_a) => {
    var { onClick } = _a, props = __rest(_a, ["onClick"]);
    return (React.createElement(ExtraActionButton, Object.assign({}, props, { onClick: onClick }),
        React.createElement(FormattedMessage, { id: "close" })));
};
export const AddMemberAction = ({ action }) => {
    return (React.createElement(ExtraAction, { title: React.createElement(FormattedMessage, { id: "AddMemberAction.title" }), bodyText: React.createElement(FormattedMessage, { id: "AddMemberAction.description" }), actionButton: React.createElement(AddMemberButton, { onClick: action }) }));
};
export const CloseCommunityAction = ({ communityId, onCommunityClosed }) => {
    const { closeCommunity } = useCommunity(communityId);
    const { formatMessage } = useIntl();
    const closeConfirm = () => confirm({
        'data-qa-anchor': 'close-community',
        title: formatMessage({ id: 'CloseCommunityAction.closeConfirm.title' }),
        content: formatMessage({ id: 'CloseCommunityAction.closeConfirm.description' }),
        cancelText: formatMessage({ id: 'cancel' }),
        okText: formatMessage({ id: 'close' }),
        onOk: () => {
            closeCommunity();
            onCommunityClosed();
        },
    });
    return (React.createElement(ExtraAction, { title: React.createElement(FormattedMessage, { id: "CloseCommunityAction.title" }), bodyText: React.createElement(FormattedMessage, { id: "CloseCommunityAction.description" }), actionButton: React.createElement(CloseCommunityButton, { "data-qa-anchor": "community-edit-close-community-button", onClick: closeConfirm }) }));
};
//# sourceMappingURL=ExtraAction.js.map